export const BRP_FINANCIAL_IDENTIFIER = 'brp-financial';
export const BUFFALO_IDENTIFIER = 'buffalo';

export const isBrpFinancialIdentifier = (identifier) => (
    identifier === BRP_FINANCIAL_IDENTIFIER || identifier === BUFFALO_IDENTIFIER
);

/**
 * Legal disclosure that must appear on every page carrying the BRP Financial
 * Services branding (CAP-570). Legal-approved — do not edit, reword, or
 * truncate without sign-off.
 *
 * Defined once and imported everywhere it renders so the copy cannot drift
 * between surfaces. Render through DisclosureBlock WITHOUT `showCheckBox`: it
 * must stay non-interactive and always visible (no links, no dismiss).
 */
export const BRP_FINANCIAL_DISCLOSURE = '"BRP Financial Services" is a program brand name owned by Bombardier Recreational Products, Inc. or its affiliates (BRP) that promotes the availability of credit offered solely by Roadrunner Financial, Inc. (RF) (NMLS ID 1525116) for certain consumer credit plans extended through participating dealers to borrowers. BRP is solely responsible for its vehicle products and product-related services. Financing provided by RF is subject to credit approval, terms, and conditions. Roadrunner Account Services, LLC (NMLS ID 1758660) services these accounts on behalf of their owner, RF or its assignee. RF and Roadrunner Account Services, LLC are not affiliated with BRP or its affiliates.';
